export default "<section id=\"gallery\">\n  \n\n</section>"